module.exports = __webpack_public_path__ + "static/img/6.859beb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/6.png
// module id = 7mI7
// module chunks = 0